import DetailedProjectReport from "src/components/feature/DetailedProjectReport";

const DefaultDetailedProjectReport = () => {
  return <DetailedProjectReport />;
};

export default DefaultDetailedProjectReport;
